module.exports = __webpack_public_path__ + "static/media/faqs.f7e8006a.svg";